import { IntegrationType } from './mixins';

export const IntegrationsArray: IntegrationType[] = [
	{
		category: 'news',
		categorySlug: 'News',
		name: 'nytimes',
		nameSlug: 'NY Times'
	},
	{
		category: 'news',
		categorySlug: 'News',
		name: 'espn',
		nameSlug: 'ESPN'
	},
	{
		category: 'news',
		categorySlug: 'News',
		name: 'techcrunsh',
		nameSlug: 'TechCrunsh'
	},
	{
		category: 'news',
		categorySlug: 'News',
		name: 'chess.com',
		nameSlug: 'chess.com'
	},
	{
		category: 'news',
		categorySlug: 'News',
		name: 'yahoo finance',
		nameSlug: 'Yahoo Finance'
	},
	{
		category: 'news',
		categorySlug: 'News',
		name: 'bbc',
		nameSlug: 'BBC'
	},
	{
		category: 'news',
		categorySlug: 'News',
		name: 'technology review',
		nameSlug: 'Technology Review'
	},
	{
		category: 'news',
		categorySlug: 'News',
		name: 'lifehacker',
		nameSlug: 'Lifehacker'
	},
	{
		category: 'news',
		categorySlug: 'News',
		name: 'mashable',
		nameSlug: 'Mashable'
	},
	{
		category: 'news',
		categorySlug: 'News',
		name: 'forbes billionaires',
		nameSlug: 'Forbes Billionaires'
	},
	{
		category: 'news',
		categorySlug: 'News',
		name: 'mr money mustache',
		nameSlug: 'MR Money Mustache'
	},
	{
		category: 'news',
		categorySlug: 'News',
		name: 'space',
		nameSlug: 'Space'
	},
	{
		category: 'news',
		categorySlug: 'News',
		name: 'elon musk news',
		nameSlug: 'Elon Musk News'
	},
	{
		category: 'news',
		categorySlug: 'News',
		name: 'crypto',
		nameSlug: 'Crypto'
	},
	{
		category: 'news',
		categorySlug: 'News',
		name: 'soccer',
		nameSlug: 'Soccer'
	},
	{
		category: 'news',
		categorySlug: 'News',
		name: 'basketball',
		nameSlug: 'Basketball'
	},
	{
		category: 'news',
		categorySlug: 'News',
		name: 'meditation',
		nameSlug: 'Meditation'
	},

	// Other Integrations
	{
		category: 'music',
		categorySlug: 'Music',
		name: 'spotify',
		nameSlug: 'Spotify'
	},
	{
		category: 'pictures',
		categorySlug: 'Pictures',
		name: 'unsplash',
		nameSlug: 'Unsplash'
	},
	{
		category: 'video',
		categorySlug: 'Video',
		name: 'youtube',
		nameSlug: 'Youtube'
	},
	{
		category: 'crypto',
		categorySlug: 'Crypto',
		name: 'coincap',
		nameSlug: 'CoinCap'
	}
];
